import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"flex\" ...attributes>\n  {{yield}}\n</div>",{ moduleName: "my-phorest/components/ui/form-layout/-common/-actions/index.hbs" })